import { ArrowUp } from "lucide-react";
import { PROFILE } from "../data/projects";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#111] py-12 text-white">
    <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-6 text-center">
      <a
        data-testid="footer-logo"
        href="#home"
        onClick={(e) => {
          e.preventDefault();
          window.__lenis?.scrollTo(0, { duration: 1.4 });
        }}
        className="text-2xl font-bold tracking-tight"
      >
        Harshith<span className="text-accent">.</span>
      </a>
      <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 text-xs uppercase tracking-[0.2em] text-white/50">
        <a data-testid="footer-behance-link" href={PROFILE.behance} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-accent">
          Behance
        </a>
        <a data-testid="footer-linkedin-link" href={PROFILE.linkedin} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-accent">
          LinkedIn
        </a>
        <a data-testid="footer-facebook-link" href={PROFILE.facebook} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-accent">
          Facebook
        </a>
        <a data-testid="footer-whatsapp-link" href={PROFILE.whatsapp} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-accent">
          WhatsApp
        </a>
        <a data-testid="footer-linktree-link" href={PROFILE.linktree} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-accent">
          Linktree
        </a>
      </div>
      <p className="text-xs text-white/40">© 2026 {PROFILE.name} — All Rights Reserved. Designed in London.</p>
      <button
        data-testid="footer-back-to-top-btn"
        onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
        aria-label="Back to top"
        className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 transition-colors duration-400 hover:border-accent hover:bg-accent"
      >
        <ArrowUp className="h-4 w-4" />
      </button>
    </div>
  </footer>
);
